import { useRecurringOverdueCount } from '../routes/recurring/useRecurringOverdueCount'
import { RECURRING_PATH } from '../routes/recurring/recurringPaths'
import { navBadge, type NavBadges } from './nav'

/**
 * The nav's live counts, read once by `ChromeLayout` and handed to the sidebar
 * and the More sheet, which stay presentational. Each entry names its producer
 * (`nav.ts`'s `badge` docblock); a path with no producer has no badge.
 */
export function useNavBadges(): NavBadges {
  // D11, Ruling 50: the Overdue tile's number for the current month, hidden at 0.
  const overdue = navBadge(useRecurringOverdueCount())
  return { [RECURRING_PATH]: overdue }
}
